import { Component, Inject } from '@angular/core';

import { OnInit } from '@angular/core';

import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GlobalCfgService } from 'src/services/globalcfg.service';
import { EventBusService } from 'src/services/event-bus.service';
import { MiscService } from 'src/services/misc.service';
import { MessageService } from 'src/services/message.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { FileUploadService } from 'src/services/file-upload.service';
import { UserService } from 'src/services/user.service';
import { Utils } from 'src/services/utils';
import {environment} from '../../../environments/environment';
import { AuthService } from 'src/services/auth.service';

@Component({
    selector: 'rm-add-manufacturer',
    templateUrl: './add-organisation.component.html',
    styleUrls: ['./add-organisation.component.css']
})
export class AddManufacturerDialogComponent implements OnInit {

    user: any = {};
    isReadOnly: boolean = false;

    countries: any[];
    states: any[];

    types: any[];

    selectedCountry;
    selectedState;
    selectedCity;

    uploader: any;
    attachment: any;

    statesSource = new Subject<any>();
    statesValue$ = this.statesSource.asObservable();

    countriesSource = new Subject<any>();
    countriesValue$ = this.countriesSource.asObservable();

    hasGlobalPresence: boolean = true;
    presenceCountryId: string;
    mobileRegEx: string = "^[(]{0,1}[+0-9]{2,4}[)]{0,1}[0-9]{10}|[(]{0,1}[+][0-9]{1,2}-[0-9]{3,4}[)]{0,1}[0-9]{10}$";

    formGroup = new FormGroup({
        id: new FormControl(),
        gcp: new FormControl(),
        legalName: new FormControl(),
        uniqueIdentifierNumber: new FormControl(), // camtrade pass attribute
        password: new FormControl('', [Validators.minLength(8), Validators.maxLength(64)]),
        // confirmPassword: new FormControl('', [Validators.minLength(8), Validators.maxLength(64)]),
        mobile: new FormControl('', Validators.maxLength(20)),
        email: new FormControl(),
        // hasGlobalPresence: new FormControl(true),
        // presenceCountryId: new FormControl(),
        url: new FormControl(),
        firstName: new FormControl(),
        lastName: new FormControl(),
        mfgAddress: new FormControl(),
        address: new FormControl(),
        countryId: new FormControl(),
        stateId: new FormControl(),
        // stateName: new FormControl(),
        city: new FormControl(),
        pincode: new FormControl(),
        userId: new FormControl(),
        isActive: new FormControl(),
        type: new FormControl(),
        dappUserId: new FormControl()
    });
    subscriptions: any[] = [];
    profilePicPath: string;
    showCountrySelection: boolean;
    mode: any;

    labelLevel: any[] = [
        { name: "Class level", value: "class"},
        { name: "Batch/Lot level", value: "batch"},
        { name: "Instance level", value: "instance"},
    ];

    booleanValue: any[] = [
        { name: "Yes", value: true},
        { name: "No", value: false},
    ];

    notificationSettings: any[] = [
        { name: "Inform", value: "info"},
        { name: "Warn", value: "warn"},
        { name: "Invalidate", value: "error"},
    ];

    serilizationLevel: string = "instance";
    isGenerateLabelFile: boolean;
    isEmailFile: boolean = true;
    isLocTracking: boolean = true;
    isGeoFencing: boolean = true;
    isAdvancedEventAnalytics: boolean = false;
    batchRecalledEvent: string = "error";
    expiredEvent: string = "error";
    ownershipEvent: string = "warn";
    nsqEvent: string = "error";
    bannedEvent: string = "error";
    notForSaleEvent: string = "error";
    soldEvent: string = "info";
    envCondEvent: string = "warn";
    geoFenceEvent: string = "warn";
    batchCancelEvent: string = "error";
    fakeEvent: string = "error";
    alreadySoldEvent: string = "error";
    prescriptionEvent: string = "error";
    routeEvent: string = "warn";
    constructor(
        private dialogRef: MatDialogRef<AddManufacturerDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private miscService: MiscService,
        private userService: UserService,
        private globalCfgService: GlobalCfgService,
        private uploadService: FileUploadService,
        private busService: EventBusService,
        private utils: Utils,
        private msgService: MessageService,
        private authService: AuthService
    ) { }

    ngOnInit() {
        this.subscriptions.push(this.statesValue$.subscribe(
            () => {
                if (this.selectedState !== null && this.selectedState !== undefined) {
                    this.setStateIdFormControlValue(this.selectedState);
                }
            }
        ));

        this.subscriptions.push(this.countriesValue$.subscribe(
            () => this.loadStates(this.selectedCountry)
        ));
        this.loadCountries();

        this.uploader = this.uploadService.getUploader(environment.profilePicsContainer);
        if (this.data.data) {
            this.hasGlobalPresence = this.data.data.hasGlobalPresence;
            this.showCountrySelection = !this.data.data.hasGlobalPresence;
            if (this.showCountrySelection) {
                this.presenceCountryId = this.data.data.presenceCountryId;
            }
            this.formGroup.patchValue(this.data.data);
            this.formGroup.controls['gcp'].disable();
        }

        this.authService.getRoles().subscribe(
            (result: any)=> {
                this.types = result;
            }
        );

        this.mode = this.data.mode;
    }

    /**
     * 
     * run when state value is to be set from get location geocode
     */
    setStateIdFormControlValue(selectedState) {
        let stateObjIndex = -1;
        
        // check if geocode state shortname matches state obj 'code'
        stateObjIndex = this.states.findIndex(state => {
            return state.code === selectedState;
        });
        if (stateObjIndex > -1) {
            this.formGroup.controls.stateId.setValue(this.states[stateObjIndex].code);
        } else {
            // special case to check where shortname matches state obj 'name'
            stateObjIndex = this.states.findIndex(state => {
                return state.name === this.selectedState;
            });
            if (stateObjIndex > -1) {
                this.formGroup.controls.stateId.setValue(this.states[stateObjIndex].code);
            } else {
                this.formGroup.controls.stateId.setValue(null);
            }
        }
    }

    private onFileSelected() {
        this.uploader.response.subscribe(
            response => {

                this.attachment = JSON.parse(response)["result"]["files"]["file"][0];
                // this.profilePicPath =
                //     "/uploads/" + this.attachment.container + "/" + this.attachment.name;
                this.profilePicPath = this.attachment.providerResponse.location;
            },
            error => {
                console.log("File upload error:", error);
            }
        );
    }

    getLocation() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
                success => {
                    let GEOCODING = `${environment.geoCodeUrl}${success.coords.latitude}%2C${success.coords.longitude}&key=${environment.geoCodeAPI}`;

                    this.userService.getLocation(GEOCODING).subscribe((location: any) => {

                        if (location.status != 'OK') {
                            this.msgService.showError(this.msgService.addDetailFail);
                        }

                        let pincodeValue,
                            addressArray = location["results"][0].address_components;
                        let addressValue = location["results"][0].formatted_address;
                        addressArray.forEach(address => {
                            if ("country" == address.types[0]) {
                                this.selectedCountry = address.short_name;
                            } else if ("postal_code" == address.types[0]) {
                                pincodeValue = address.short_name;
                            } else if ("administrative_area_level_1" == address.types[0]) {
                                this.selectedState = address.short_name;
                            } else if ("administrative_area_level_2" == address.types[0]) {
                                this.selectedCity = address.short_name;
                                this.formGroup.controls.city.setValue(this.selectedCity);
                            }
                        });

                        
                        this.loadStates(this.getCountryObj(this.selectedCountry).id);
                        this.formGroup.controls.pincode.setValue(pincodeValue);
                        console.log("#posttal " + pincodeValue);
                        this.formGroup.controls.countryId.setValue(
                            this.selectedCountry
                        );
                        console.log("#country " + this.selectedCountry);
                        this.formGroup.controls.address.setValue(addressValue);
                    });
                },
                error => {
                    this.msgService.showError(this.msgService.browserSupportFail);
                 }
            );
        }
    }

    getCountryObj(countryId) {
        return this.utils.getObject(
            "code",
            countryId,
            this.countries
        );
    }

    onStateChange(stateId) {
        this.formGroup.controls.city.setValue(null);
        this.formGroup.controls.pincode.setValue(null);
        this.formGroup.controls.address.setValue(null);
        var state = this.utils.getObject(
            "code",
            stateId,
            this.states
        );

        // this.formGroup.controls.stateName.setValue(state.name);
    }

    onChangeCountry(countryId) {
        this.selectedState = null;
        this.states = [];
        this.formGroup.controls.stateId.setValue(this.selectedState);
        this.formGroup.controls.city.setValue(null);
        this.formGroup.controls.pincode.setValue(null);
        this.formGroup.controls.address.setValue(null);
        

        this.loadStates(this.getCountryObj(countryId).id);
    }

    private loadCountries() {
        this.miscService.getCountries().subscribe(
            (response: any[]) => {
                this.countries = response["data"];
                this.selectedCountry = this.countries[0].id;

                this.countriesSource.next();
            },
            error => {
                console.log("Service failed:", error);
            }
        );
    }

    private loadStates(countryId) {
        this.miscService.getStates(countryId).subscribe(
            (response: any[]) => {
                this.states = response["data"];

                this.statesSource.next();
            },
            error => {
                console.log("Service failed:", error);
            }
        );
    }

    onSubmit(rec) {
        // console.log(rec);

        var mfgRec = {
            gcp: rec.gcp,
            legalName: rec.legalName,
            uniqueIdentifierNumber: rec.uniqueIdentifierNumber, // camtrade pass attribute
            address: rec.mfgAddress,
            isActive: true,
            url: rec.url,
            hasGlobalPresence: this.hasGlobalPresence || false,
            presenceCountryId: this.presenceCountryId || null,
            contact: {
                firstName: rec.firstName,
                lastName: rec.lastName,
                countryId: rec.countryId,
                stateId: rec.stateId,
                city: rec.city,
                address: rec.address,
                pincode: rec.pincode,
                email: rec.email,
                mobile: rec.mobile
            },
            type: rec.type,
            dappUserId: rec.dappUserId,
            options: {
                serilizationLevel: this.serilizationLevel,
                isGenerateLabelFile: this.isGenerateLabelFile,
                isEmailFile: this.isEmailFile,
                isLocTracking: this.isLocTracking,
                isGeoFencing: this.isGeoFencing,
                isAdvancedEventAnalytics: this.isAdvancedEventAnalytics,
                BATCHRECALLED: this.batchRecalledEvent,
                EXPIRED: this.expiredEvent,
                OWNERSHIPBREACHED: this.ownershipEvent,
                NSQ: this.nsqEvent,
                BANNED: this.bannedEvent,
                NOTFORSALE: this.notForSaleEvent,
                ALREADYSOLD: this.soldEvent,
                INVALIDLABEL: this.batchCancelEvent,
                FAKE: this.fakeEvent,
                ALREADYSOLDEVENT: this.alreadySoldEvent,
                GEOFENCED: this.geoFenceEvent,
                PRESCRIPTIONONLY: this.prescriptionEvent,
                NORMAL: "info",
                OVERHEATED : this.envCondEvent,
                OVERCOOLED : this.envCondEvent,
                HIGHHUMIDITY : this.envCondEvent,
                LESSHUMIDITY : this.envCondEvent
            }
        };

        if (this.mode == 'edit') {

            mfgRec['id'] = rec.id;
            mfgRec['contactId'] = rec.contactId;

            this.miscService.updateOrganisation(mfgRec).subscribe(
                ()=> {
                    this.msgService.showSuccess(this.msgService.organisationCreate);
                    this.dialogRef.close('yes');
                }
            );

        } else {
            this.miscService.addOrganisation(mfgRec).subscribe(
                ()=> {
                    this.msgService.showSuccess(this.msgService.organisationCreate);
                    this.dialogRef.close('yes');
                }
            );
        }
    }

    cancel() {
        this.dialogRef.close('no');
    }
}